import React, { ReactElement } from 'react'

function Step4Tooltip(): ReactElement {
  return (
    <div className="card px15 py2 cardSm textPrimaryDark w23 fontSizeXs">
      <i className="lh2">
        Louvre Banque privée en tant qu’établissement financier, conformément à
        la règlementation en vigueur doit disposer de votre adresse postale et
        s’assurer que vous êtes en mesure de recevoir toute information
        importante.
      </i>
    </div>
  )
}

export default Step4Tooltip
